export default __webpack_public_path__ + "static/media/au.eb0518ba.svg";